// BASES
export const ROUTE_DASHBOARD = "/";

export const ROUTE_USERS = "/users";

export const ROUTE_STATICS = "/statics";
export const ROUTE_USER_INSPECTIONS = "/inspections";

export const ROUTE_AUTO_LOGIN_MAIN = "/autologin";
export const ROUTE_AUTO_LOGIN = "/autologin/:key/:province";
